import { Breadcrumbs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import AboutImg from "../../components/assets/about_img.webp";
import NoInternetComp from "../../components/common/InternetConnetction/NoInternetComp";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";

function AboutUsPage() {
  const [aboutData, setAboutData] = useState("");
  const [loading, setLoading] = useState({ page: false });
  const access_token = localStorage.getItem("user-access-token");

  useEffect(() => {
    fetchAboutusData();
  }, []);

  const fetchAboutusData = async () => {
    setLoading({ ...loading, page: true });

    try {
      const res = await getServices(`/api/cms/about`, access_token);

      setLoading({ ...loading, page: false });
      if (res.responseCode === 200) {
        setAboutData(res.responseData?.about ?? "");
      } else {
        setAboutData("");
        toast.error(res.responseMessage || "Something went worng");
      }
    } catch (error) {
      setLoading({ ...loading, page: false });
      toast.error(error || "Something went wrong");
    }
  };

  return (
    <>
      <Container className="flex justify-center px-4 pt-2 pb-20">
        <Container className="max-w-7xl w-full mb-3 flex flex-col gap-3">
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
            sx={{
              fontFamily: "Poppins",
            }}
          >
            <Link underline="hover" color="inherit" to="/profile">
              Profile
            </Link>
            <Typography
              color="text.primary"
              sx={{
                fontFamily: "Poppins",
              }}
            >
              About us
            </Typography>
          </Breadcrumbs>

          {navigator.onLine ? (
            !loading.page ? (
              aboutData ? (
                <div>
                  <h1 className="font-semibold text-2xl">About us</h1>
                  <hr className="w-[5%] border-black border-2 mb-5" />

                  <div
                    className="prose prose-gray max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: aboutData,
                    }}
                  />
                  {/* <div className="flex flex-col md:flex-row items-center gap-4">
                    <p className="text-left">
                      At Solmelu Gift Gallery, we bridge the world of business
                      and creativity — connecting mid- to large-sized
                      corporations, HR & People Ops teams, Sales & Marketing
                      divisions, Admin & Procurement departments, resellers,
                      SMEs, event planners, and coworking spaces to a trusted
                      network of verified artisans, manufacturers, importers,
                      and distributors across India.
                      <br />
                      <br />
                      We exist to make corporate gifting seamless, purposeful,
                      and memorable — helping organisations celebrate people,
                      milestones, and partnerships through gifts that tell
                      stories and strengthen relationships.
                    </p>
                  </div>

                  <hr className="w-[5%] border-black border-2" />
                  <p className="font-semibold text-xl text-gray-600">
                    Our Vision
                  </p>
                  <p className="text-left">
                    To build a gifting ecosystem that empowers companies to
                    choose gifts that reflect their culture and care — while
                    uplifting the creators behind every product. We bring
                    together the best of both worlds — creative craftsmanship
                    and professional reliability — to ensure every gift is
                    delivered with meaning, timeliness, and excellence.
                  </p>

                  <hr className="w-[5%] border-black border-2" />
                  <p className="font-semibold text-xl text-gray-600">
                    What We Do
                  </p>
                  <p className="text-left font-semibold">
                    1. Verified, Transparent Supply Network
                  </p>
                  <p className="text-left">
                    We partner with a diverse ecosystem of artisans, small
                    manufacturers, importers, and resellers, ensuring every
                    product is ethically sourced, fairly priced, and
                    quality-assured.
                  </p>

                  <p className="text-left font-semibold">
                    2. Creativity Meets Accountability
                  </p>
                  <p className="text-left">
                    Our in-house curation team onboards gifting solutions that
                    are innovative, aesthetic, and brand-aligned, while our
                    backend systems ensure transparency, documentation, and
                    accountability at every stage.
                  </p>

                  <p className="text-left font-semibold">
                    3. Customisable & Personalised
                  </p>
                  <p className="text-left">
                    We champion locally crafted products, and custom-designed
                    collections that help companies give responsibly and
                    memorably.
                  </p>

                  <hr className="w-[5%] border-black border-2" />
                  <p className="font-semibold text-xl text-gray-600">
                    Our Promise
                  </p>
                  <p className="text-left">
                    At Solmelu, we want to deliver gifts and experiences that
                    connect people.
                  </p> */}
                </div>
              ) : (
                <Container className="text-center mx-8 mt-5 sm:mt-5 min-h-[35vh]">
                  <p className="font-semibold">No data found!!!</p>
                </Container>
              )
            ) : (
              <Container className="min-h-[35vh] flex justify-center items-center">
                <p className="text-center font-semibold">Loading...</p>
              </Container>
            )
          ) : (
            <Container className="min-h-[65vh] flex flex-col justify-center items-center">
              <NoInternetComp />
            </Container>
          )}
        </Container>
      </Container>
    </>
  );
}

export default AboutUsPage;
